export default __webpack_public_path__ + "static/media/proquest.6911d3a0.png";